import DataStudioService from 'src/modules/dataStudio/dataStudioService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'DATASTUDIO_FORM';

const dataStudioFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: dataStudioFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await DataStudioService.find(id);
      }

      dispatch({
        type: dataStudioFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataStudioFormActions.INIT_ERROR,
      });

      getHistory().push('/data-studio');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: dataStudioFormActions.CREATE_STARTED,
      });

      await DataStudioService.create(values);

      dispatch({
        type: dataStudioFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.dataStudio.create.success'),
      );

      getHistory().push('/data-studio');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataStudioFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: dataStudioFormActions.UPDATE_STARTED,
      });

      await DataStudioService.update(id, values);

      dispatch({
        type: dataStudioFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.dataStudio.update.success'),
      );

      getHistory().push('/data-studio');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataStudioFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default dataStudioFormActions;
